import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { ChartTimelineIcon } from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import { useInterval } from '../../../../../helpers/custom-hooks';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import './quarterly-results.m.css';

const QuarterlyResults = () => {
  const [quarterResultsData, setQuarterResultsData] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getQuarterlyResultsData = async () => {
    const retrievedStockId = fetchStockId();
    const response = await fetch(`/next/feapi/stock/quarterly-results/${retrievedStockId}`);
    const data = await response.json();
    setQuarterResultsData(data?.data);
  };

  useEffect(() => {
    if (initialLoading) {
      setInitialLoading(false);
      getQuarterlyResultsData();
    }
  }, []);

  useInterval(() => {
    if (isWithinTradingHours(tradingHolidays, specialTradingDays)) {
      getQuarterlyResultsData();
    }
  }, 30000);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="quarterly-results-container">
      <div styleName="header-title-container">
        <ChartTimelineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">QUARTERLY RESULTS</h2>
      </div>
      {quarterResultsData && !isEmpty(quarterResultsData) ? (
        <>
          <div styleName="header-container">
            <div styleName="data-container">
              {quarterResultsData?.headerMsg?.map((result, index) =>
                result.dir > 0 ? (
                  <div styleName="info-card" key={index}>
                    <div>
                      <span className="icon-ic_lightbulb" />
                      <span>ADVANCES</span>
                    </div>
                    <span>{result.msg}</span>
                  </div>
                ) : (
                  <div styleName="info-card-negative" key={index}>
                    <div>
                      <span className="icon-ic_lightbulb" />
                      <span>DECLINES</span>
                    </div>
                    <span>{result.msg}</span>
                  </div>
                ),
              )}
            </div>
            <div styleName="info-container">
              <p styleName="info-text">
                Figures in Rs. cr. Non Seasonal companies are compared with the immediately
                preceding quarter
              </p>
            </div>
          </div>
          <div styleName="quarterly-results-body">
            <table>
              <tr>
                <th>Parameters</th>
                <th>{quarterResultsData?.tableHeaders?.quarter1}</th>
                <th>{quarterResultsData?.tableHeaders?.quarter2}</th>
                <th>{quarterResultsData?.tableHeaders?.quarter3}</th>
                <th>{quarterResultsData?.tableHeaders?.chgp}</th>
              </tr>
              {quarterResultsData?.tableDetails?.map((detail, index) => (
                <tr key={index}>
                  <td styleName="detail-description table-cell-padding">{detail?.text}</td>
                  <td styleName="detail-value table-cell-padding">{detail?.quarter1}</td>
                  <td styleName="detail-value table-cell-padding">{detail?.quarter2}</td>
                  <td styleName="detail-value table-cell-padding">{detail?.quarter3}</td>
                  <td styleName="detail-change-percentage table-cell-padding">
                    {detail?.chgp === '' ? (
                      0
                    ) : (
                      <span styleName={detail?.chgp < 0 ? 'detail-negative' : 'detail-positive'}>
                        {detail?.chgp}%
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default QuarterlyResults;
